export default __webpack_public_path__ + "static/media/consolation-prize.46e85b22.svg";